<template>
  <div class="question-content">
    <h1 class="title">{{ detail.title }}</h1>
    <div class="user">
      <img
        class="avatar"
        :src="addOssParamsForcibly(authUser.avatar, 100)"
        alt=""
      />
      <span class="name">{{ authUser.nickname }}</span>
    </div>
    <div class="tips" v-if="tagNames.length">
      <span class="tip" v-for="tag in tagNames" :key="tag">#{{ tag }}</span>
    </div>
    <div class="content" :class="{ 'content-max': showContentMax }">
      <YxlMore
        :lineClamp="3"
        :info="detail.content"
        @setShowAllCallback="yxlMoreUpdated"
      ></YxlMore>
    </div>
    <div class="des">
      <div class="left">
        <div class="left-item">
          <span class="num">{{ detail.seenum }}</span
          ><span>阅读</span>
        </div>
        <div class="left-item">
          <span class="dot">·</span
          ><span class="num">{{ detail.commentnum }}</span
          ><span>回答</span>
        </div>
      </div>
      <div class="right">
        <div class="right-price" v-if="detail.rewardInfo" @click="showPopup">
          <div class="price">
            <i class="m-icon"></i>¥{{ detail.rewardInfo.money }}
          </div>
          <div class="tip-qa"><i class="w-icon"></i></div>
        </div>
        <div
          class="right-collect"
          :class="{ active: +detail.isFavorite === 1 }"
          @click="collect"
        >
          <i class="collect-icon"></i>
          <div class="collect-text">
            {{ +detail.isFavorite === 1 ? '已收藏' : '收藏' }}
          </div>
        </div>
      </div>
    </div>
    <!-- 悬赏弹窗 -->
    <van-popup
      class="popup"
      position="center"
      v-model="show"
      :close-on-click-overlay="false"
      @click-overlay="show = false"
    >
      <div class="popup-content">
        <div class="popup-handle">
          <div class="info">
            <div class="popup-title" v-html="popupTitle"></div>
            <div class="popup-tip">
              {{
                `悬赏截止日期为：${
                  detail.rewardInfo && detail.rewardInfo.endTime
                }`
              }}
            </div>
            <div class="popup-btn" @click="show = false">去回答问题</div>
            <div class="popup-what" @click="goInfo">
              <i class="icon-what"></i>如何瓜分赏金
            </div>
          </div>
        </div>
        <!-- <div class="popup-cancel" @click="show = false"></div> -->
      </div>
    </van-popup>
  </div>
</template>

<script>
import YxlMore from 'component/common/yxlMore.vue'
import { isObject } from 'utils/tool.js'
import { Popup } from 'vant'
// import { Dialog } from 'vant'
import { addOssParamsForcibly } from 'utils/tool.js'
import { storeQuestion } from 'api/qa/index.js'

export default {
  props: {},
  components: {
    YxlMore,
    [Popup.name]: Popup
  },
  data() {
    return {
      showContentMax: true,
      show: false
    }
  },
  computed: {
    tagNames() {
      const { tagNames } = this.detail
      return Array.isArray(tagNames) ? tagNames : []
    },
    authUser() {
      const { authUser } = this.detail
      return isObject(authUser) ? authUser : {}
    },
    detail() {
      return this.$store.state.qaQuestionDetail.detail || {}
    },
    questionId() {
      const id = this.$route.params.id
      return id
    },
    popupTitle() {
      let text = `金额包含<br />`
      if (this.detail.rewardInfo?.platformMoney) {
        text = text + `平台${this.detail.rewardInfo.platformMoney}元`
      }
      if (this.detail.rewardInfo?.questionerMoney) {
        text =
          text +
          `${this.detail.rewardInfo.platformMoney ? ' +' : ''} 题主${
            this.detail.rewardInfo.questionerMoney
          }元`
      }
      return text
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.showContentMax = false
    })
  },
  methods: {
    addOssParamsForcibly,
    showPopup() {
      this.show = true
      // 埋点
      this.$trackEvent('qa_question_details_offer', {})
    },
    // 查看引导
    goInfo() {
      const articleId = `100412640`
      if (this.$platform.isYixinliApp) {
        window.location.href = `yixinli://open_article?article_id=${articleId}`
      } else {
        window.location.href = `https://m.xinli001.com/info/${articleId}`
      }
    },
    yxlMoreUpdated(flag) {
      if (flag) {
        this.$trackEvent('qa_question_details_all', {
          qa_id: this.$route.params.id //问题ID
        })
      }
    },
    // 收藏
    collect() {
      storeQuestion(this.questionId).then(res => {
        let message = ''
        if (+res.code === 0) {
          let { is_store } = res.data
          this.$store.commit('qaQuestionDetail/setCollect', is_store)
          message = +is_store === 1 ? '已收藏' : '已取消收藏'
        } else {
          message = res.message
        }
        this.$toast({
          text: message,
          time: 1500
        })
      })
    }
  }
}
</script>

<style lang="scss">
.qa-question-detail-vant-dialog {
  width: 560px !important;
  .van-dialog__content--isolated {
    min-height: auto !important;
  }
  .van-dialog__header {
    font-size: 32px !important;
    font-weight: 600 !important;
    color: #21252d !important;
  }
  .van-dialog__message {
    font-size: 28px !important;
    font-weight: 400 !important;
    color: #6c798c !important;
    text-align: left !important;
  }
  .van-dialog__cancel {
    font-size: 32px !important;
    font-weight: 600 !important;
    color: #9da3ac !important;
  }
  .van-dialog__confirm {
    font-size: 32px !important;
    font-weight: 600 !important;
    color: #6982fa !important;
  }
}
</style>

<style lang="scss" scoped>
.question-content {
  padding: 26px 32px 0 32px;
  background: #fff;
  .title {
    font-size: 48px;
    font-weight: 600;
    color: #000000;
    line-height: 72px;
    word-break: break-all;
  }
  .user {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    .name {
      margin-left: 12px;
      font-size: 30px;
      font-weight: 400;
      color: #21252d;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .tips {
    margin-top: 20px;
    display: flex;
    align-items: center;
    .tip {
      padding: 8px;
      margin-right: 12px;
      background: #f2f4ff;
      border-radius: 6px;
      font-size: 24px;
      font-weight: 400;
      color: #6c798c;
      line-height: 1;
    }
  }
  .content {
    margin-top: 24px;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6c798c;
    line-height: 49px;
    white-space: pre-line;
  }
  .content-max {
    max-height: 136px;
    overflow: hidden;
  }
  .des {
    min-height: 86px;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #f3f4f5;
    .left {
      display: flex;
      align-items: center;
      .left-item {
        font-size: 26px;
        font-weight: 400;
        color: #9da3ac;
        .num {
          margin-right: 8px;
          color: #21252d;
        }
        .dot {
          margin: 0 6px;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      .right-price {
        display: flex;
        align-items: center;
        .price {
          display: flex;
          align-items: center;
          padding: 0 14px 0 16px;
          height: 50px;
          background: #f2f4ff;
          border-radius: 25px 0px 0px 25px;
          font-size: 22px;
          font-weight: 600;
          color: #6c798c;
          .m-icon {
            margin-right: 6px;
            width: 32px;
            height: 32px;
            background: url('~images/qa/questions/icon-money.png') no-repeat
              center/100% 100%;
          }
        }
        .tip-qa {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          height: 50px;
          background: #e8ebff;
          border-radius: 0px 100px 100px 0px;
          .w-icon {
            width: 20px;
            height: 20px;
            background: url('~images/qa/questions/icon-wen.png') no-repeat
              center/100% 100%;
          }
        }
      }
      .right-collect {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 140px;
        height: 50px;
        margin-left: 16px;
        background: #fffbe0;
        border-radius: 25px;
        font-size: 22px;
        font-weight: 400;
        color: #ffb508;
        .collect-icon {
          width: 32px;
          height: 32px;
          margin-right: 8px;
          background: url('~images/qa/questions/icon-shoucang.png') no-repeat
            center/100% 100%;
        }
        &.active {
          background: #f3f4f5;
          color: #9da3ac;
          .collect-icon {
            background: url('~images/qa/questions/icon-yishoucang.png')
              no-repeat center/100% 100%;
          }
        }
      }
    }
  }
  ::v-deep .van-popup {
    background: transparent !important;
  }
  .popup-content {
    padding: 0 0 0 37px;
    .popup-handle {
      position: relative;
      width: 597px;
      height: 680px;
      background: url('~images/qa/questions/mask-bg.png') no-repeat center/100%
        100%;
      .info {
        position: absolute;
        top: 168px;
        left: 0;
        width: 560px;
        height: 512px;
        padding-top: 80px;
        box-sizing: border-box;
        text-align: center;
        .popup-title {
          font-size: 32px;
          font-weight: 600;
          color: #21252d;
          line-height: 52px;
        }
        .popup-tip {
          margin-top: 16px;
          font-size: 28px;
          font-weight: 400;
          color: #6c798c;
          line-height: 49px;
        }
        .popup-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 400px;
          height: 86px;
          margin: 65px auto 0;
          background: linear-gradient(270deg, #feb3a4 0%, #fc7052 100%);
          border-radius: 48px;
          font-size: 32px;
          font-weight: 600;
          color: #ffffff;
        }
        .popup-what {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 40px;
          font-size: 30px;
          font-weight: 400;
          color: #9da3ac;
          line-height: 30px;
          .icon-what {
            margin-right: 10px;
            width: 24px;
            height: 24px;
            background: url('~images/qa/questions/icon-wenhao.png') no-repeat
              center/100% 100%;
          }
        }
      }
    }
    .popup-cancel {
      width: 44px;
      height: 44px;
      box-sizing: border-box;
      margin: 56px auto 0;
      transform: translateX(-37px);
      background: url('~images/qa/questions/icon-close.png') no-repeat
        center/100% 100%;
    }
  }
}
</style>
